import { LIMPAR_FILTRO_SELECAO_EMPRESA } from '../types';


export default function limparFiltroSelecaoEmpresa() {
  return {
    type: LIMPAR_FILTRO_SELECAO_EMPRESA,
  };
}
